export default {"src":"/_next/static/media/mobile-icon.cfbd54e3.svg","height":40,"width":40};